import React from 'react';
import { Organizador } from '../../services/organizadorService';
import { ORGANIZADOR_FUNCOES } from '../../pages/admin/organizer/components/TournamentOrganizerItem';

interface LeagueOrganizerItemProps {
  organizador: Omit<Organizador, 'id'> & { id?: string };
  onDelete?: () => void;
  busy?: boolean;
  readOnly?: boolean;
  disableDeleteReason?: string;
}

const LeagueOrganizerItem: React.FC<LeagueOrganizerItemProps> = ({
  organizador,
  onDelete,
  busy = false,
  readOnly = false,
  disableDeleteReason,
}) => {
  const disabled = readOnly || busy;
  const deleteDisabled = !onDelete || disabled || !!disableDeleteReason;

  const funcaoLabel =
    organizador.nomeFuncao &&
    ORGANIZADOR_FUNCOES.find((f) => f.value === organizador.nomeFuncao)?.label;

  const usuario = organizador.usuario;

  if (!usuario) {
    return null;
  }

  return (
    <div
      className={`card p-3 position-relative ${disabled ? 'opacity-75' : ''}`}
      aria-busy={busy}
    >
      {busy && (
        <div className="position-absolute top-0 start-0 w-100 h-100 bg-white bg-opacity-50 d-flex align-items-center justify-content-center rounded">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <div className="d-flex flex-column flex-md-row gap-3 align-items-center">
        <div
          className="position-relative"
          style={{ width: 120, height: 120, flex: '0 0 auto' }}
        >
          <img
            src={usuario.imagemUrl || '/assets/images/user.png'}
            alt={`Avatar de ${usuario.nome || ''}`}
            className="w-100 h-100 rounded-circle"
            style={{ objectFit: 'cover' }}
          />
        </div>

        <div className="flex-grow-1 w-100 text-center text-md-start">
          <h5 className="mb-2">{usuario.nome}</h5>
          {usuario.username && (
            <p className="text-muted mb-2">@{usuario.username}</p>
          )}
          {funcaoLabel && (
            <div className="mb-2">
              <span className="badge bg-primary">{funcaoLabel}</span>
            </div>
          )}
        </div>

        {onDelete && (
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-outline-danger btn-sm d-inline-flex align-items-center gap-2"
              onClick={onDelete}
              disabled={deleteDisabled}
              aria-label="Remover organizador"
              title={disableDeleteReason || 'Remover organizador'}
            >
              <i className="bi bi-trash" aria-hidden="true" />
            </button>
            {disableDeleteReason && (
              <small className="d-block text-muted mt-1" style={{ fontSize: '0.75rem' }}>
                {disableDeleteReason}
              </small>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeagueOrganizerItem;

